import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewBajaCabeza = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'baja_cabezaxxxx', // ya no tienen que acceder desde aca sino desde Baja Cabeza RFID todo integrado.
        name: 'Egreso hacienda ( -NO USAR - )',
        component: ViewBajaCabeza,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
